// Module
var code = "<div class=\"m-t\">\n  <machine-categories-list\n      on-error=\"onError\"\n      on-success=\"onSuccess\"\n      >\n  <machine-categories-list />\n</div>\n";
// Exports
var _module_exports = code;;
var path = '/admin/machines/categories.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;